import React from 'react';
import { Page, RedirectionLink, Title } from '../shared';
import { ReactComponent as EmailSentSVG } from '../images/EmailSent.svg';
import { ReactComponent as BeeHeroLogo } from '../images/BeeHeroLogo.svg';
import styles from './EmailSent.module.scss';
import { backToLoginText, subtitleText, titleText } from './textConsts';

const EmailSent = () => {
    return (
        <Page>
            <BeeHeroLogo width={141} className={styles['page-beehero-logo']} />
            <Page.Section>
                <Title
                    svg={EmailSentSVG}
                    title={titleText}
                    subtitle={subtitleText}
                    outerClassName={styles['title-email-sent']}
                    iconSize={97}
                />
            </Page.Section>
            <Page.Section center>
                <RedirectionLink to="/login/" text={backToLoginText} />
            </Page.Section>
        </Page>
    );
};

export default EmailSent;
